import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectLeadDetail } from '@user/store/lead'
import { selectOpportunityDetail } from '@user/store/opportunity'

export function useData(entityType: ENTITY_TYPES) {
  const isLeadDetails = entityType === ENTITY_TYPES.Lead
  const leadDetails = useSelector(selectLeadDetail)
  const opportunityDetails = useSelector(selectOpportunityDetail)

  return {
    details: isLeadDetails ? leadDetails : opportunityDetails,
    isLeadDetails,
    title: isLeadDetails ? 'Lead Detail Page' : 'Opportunity Detail Page',
  }
}
